import { render, staticRenderFns } from "./ImageSegmentation.vue?vue&type=template&id=02d04201&scoped=true"
import script from "./ImageSegmentation.vue?vue&type=script&lang=js"
export * from "./ImageSegmentation.vue?vue&type=script&lang=js"
import style0 from "./ImageSegmentation.vue?vue&type=style&index=0&id=02d04201&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d04201",
  null
  
)

export default component.exports